import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';

const ty = actionMeta.identifiers;

let initState = {
    translations: {},
    translationsLoading: false,
};

export default function reducer(state = initState, action = "") {

    //console.log("action:", action.type, " payload:", action.payload)

    if (action.type.startsWith(PREFIX)) {
        switch (action.type) {
            case ty.TRANSLATIONS_LIST_REQUEST: {
                    const {loadInBackground} = action.payload.params;
                    console.log("loadInBackground", loadInBackground)
                    if(!loadInBackground) {
                        state = {
                            ...state,
                            translationsLoading: true,
                            translations: {}
                        }
                    }
                }
                break;
            case ty.TRANSLATIONS_LIST_RESPONSE: {
                    const {project_id, project_locale_string_id, variables} = action.payload.data;
                    let changes = {};
                    const key = project_id + "_" + project_locale_string_id;

                    changes[key] = variables;

                    state = {
                        ...state,
                        translations: {
                            ...state.translations,
                            ...changes
                        },
                        translationsLoading: false
                    }
                }
                break;
            case ty.TRANSLATION_CREATE_RESPONSE:

                break;
            default:
                return state
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/translations/reducer.js